export default "__VITE_ASSET__EMp8YJzk__"